import "./stylesheets/bootstrap";
import "./stylesheets/vendor";
import "bootstrap";
import * as signalR from "@microsoft/signalr";
window.signalRNotifications = signalR;
import $ from "jquery";
window.$ = $;
window.jQuery = $;
import { COLOR_CODE } from './utils/colorcode';
window.__COLOR_CODE = COLOR_CODE;
